// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_m9-0";
export var fileCarousel = "_m9-2";
export var removeFileButton = "_m9-1";